<template>
  <div class="vue-wrapper">
    <router-view></router-view>
  </div>
</template>

<script>
import MainNavigation from '../components/Guest/TheMainNavigation'

export default {
  name: 'layout',
  components: {
    MainNavigation
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/GuestLayout.vue